export default __webpack_public_path__ + "assets/3ae1e25e-3aa6-4061-a016-a079159f9d65.woff2";